import { render, staticRenderFns } from "./PhaseIndicator.vue?vue&type=template&id=d97e066a&"
import script from "./PhaseIndicator.vue?vue&type=script&lang=js&"
export * from "./PhaseIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports